import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { getCurrentUser, logout, hasPermission } from '../utils/authUtils';
import { UserRole } from '../types/user';

const Nav = styled.nav`
  background-color: #f8f9fa;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
`;

const NavLinks = styled.div`
  display: flex;
  gap: 20px;
`;

const NavLink = styled(Link)`
  text-decoration: none;
  color: #333;
  font-weight: 500;
  
  &:hover {
    color: #007bff;
  }
`;

const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

const UserInfo = styled.span`
  color: #666;
`;

const LogoutButton = styled.button`
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  padding: 5px 10px;
  
  &:hover {
    text-decoration: underline;
  }
`;

const Navigation: React.FC = () => {
  const navigate = useNavigate();
  const currentUser = getCurrentUser();
  const isAdmin = currentUser && hasPermission(UserRole.ADMIN);
  const isSuperAdmin = currentUser?.role === UserRole.SUPER_ADMIN;

  const handleLogout = () => {
    logout();
    navigate('/auth');
  };

  if (!currentUser) {
    return (
      <Nav>
        <NavContainer>
          <NavLinks>
            <NavLink to="/auth">登录 / 注册</NavLink>
          </NavLinks>
        </NavContainer>
      </Nav>
    );
  }

  return (
    <Nav>
      <NavContainer>
        <NavLinks>
          <NavLink to="/">首页</NavLink>
          {(isAdmin || isSuperAdmin) && <NavLink to="/bookmarks">书签设置</NavLink>}
          <NavLink to="/gallery">书签导航</NavLink>
          <NavLink to="/favorites">我的收藏</NavLink>
          {isSuperAdmin && <NavLink to="/admin">管理员设置</NavLink>}
          <NavLink to="/settings">重置密码</NavLink>
        </NavLinks>
        <UserSection>
          <UserInfo>{currentUser.username}</UserInfo>
          <LogoutButton onClick={handleLogout}>退出</LogoutButton>
        </UserSection>
      </NavContainer>
    </Nav>
  );
};

export default Navigation; 